// generated file, if you want to edit this file manually change the word "generated" to "manual"

import { makeStyles } from '@material-ui/core/styles';

export const useStylesForDonutChart = makeStyles<any>(theme => ({
  DonutChart: {
    width: '70%',
    ...(theme?.DonutChart?.css || {})
  },

  line: {
    stroke: '#d0d0ce',
    strokeWidth: '20px',
    strokeLinecap: 'round',
    fill: 'none',
    ...(theme?.DonutChart?.line?.css || {})
  },
  background: {
    stroke: '#d0d0ce',
    strokeWidth: '20px',
    strokeLinecap: 'round',
    fill: 'none',
    ...(theme?.DonutChart?.background?.css || {})
  },
  text: {
    fontSize: '30px',
    alignmentBaseline: 'middle',
    ...(theme?.DonutChart?.text?.css || {})
  },
  subtitle: {
    fontSize: '20px',
    color: 'lightgray',
    alignmentBaseline: 'middle',
    ...(theme?.DonutChart?.subtitle?.css || {})
  }
}));

export default useStylesForDonutChart;
